import { render } from "./ReasonList.vue?vue&type=template&id=24c9fb0e&scoped=true"
import script from "./ReasonList.vue?vue&type=script&lang=js"
export * from "./ReasonList.vue?vue&type=script&lang=js"

import "./ReasonList.vue?vue&type=style&index=0&id=24c9fb0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c9fb0e"]])

export default __exports__